import { ControlFacturacion } from '../control-facturacion.interface';

export interface CotizacionV2 {
  folioDB: number;
  nombreAgente: string;
  centro: string;
  nombreSucursal: string;
  telefonoSucursal: string;
  fecha: string;
  nuevo: any;
  json: Cotizacion;
}

export interface Cotizacion {
  agent: string;
  zone: string;
  branch: string;
  status: string;
  cartId: string;
  cartItems: CartItem[];
  secondLastName: string;
  creditInfo: string;
  registration: string;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  income: number;
  customerType: number;
  customerId: number;
  creditAmount: number;
  branchId: number;
  agentId: number;
  zoneId: number;
}

export interface CartItem {
  description: string;
  warranties: any[] /* Falta interface de garantias */;
  image: string;
  installationSku: string;
  sku: string;
  saleType: string;
  line: string;
  purchasePlan: string;
  prices: Price[];
  luType: number;
  lu: boolean;
  purchasePlanId: number;
  quantity: number;
  l2: boolean;
  saleTypeId: number;
  kit: boolean;
  grouped: boolean;
  video: string;
  otrosEsquemas: ControlFacturacion[];
  promocionActiva?: boolean; // Viene de inventory/buscaArticulos
}

export interface Price {
  purchasePlan: string;
  priceName: string;
  installationPrice: number;
  luFactor: number;
  haveWarranty: boolean;
  priceType: number;
  deposit: number;
  purchasePlanId: number;
  quantity: number;
  salePrice: number;
  term: number;
}

export class CostFleteForeign {
  costoFleteFonaneoAproximado: number = 0;
}